import { apiFetch } from '$lib/api/client';
import { initLiveLook } from './liveLook.svelte';

// ============================================================
// Auth store - Fase 1.
//
// Runa Svelte 5 ($state). user es null cuando no hay sesion. loading
// es true mientras hace falta esperar al primer /api/auth/me; el guard
// no redirige a /login mientras loading es true para evitar flickeo.
// ai indica si el backend tiene ANTHROPIC_API_KEY configurada (Fase 8
// lo usa para mostrar el boton "Ask Claude"; en Fase 1 siempre false).
// ============================================================

export interface User {
  email: string;
  name: string;
  picture?: string;
  sub: string;
}

interface MeResponse {
  user: User | null;
  ai: boolean;
}

export const auth = $state<{ user: User | null; ai: boolean; loading: boolean }>({
  user: null,
  ai: false,
  loading: true,
});

export async function loadAuth(): Promise<void> {
  try {
    const res = await apiFetch<MeResponse>('/api/auth/me');
    auth.user = res.user;
    auth.ai = res.ai;
    initLiveLook(res.user?.email ?? null);
  } catch (err) {
    console.error('[auth] loadAuth fallo', err);
    auth.user = null;
    auth.ai = false;
  } finally {
    auth.loading = false;
  }
}

export async function logout(): Promise<void> {
  try {
    await apiFetch<void>('/api/auth/logout', { method: 'POST' });
  } catch (err) {
    console.error('[auth] logout fallo', err);
  } finally {
    auth.user = null;
  }
}
